import _ from 'lodash';
import { sharedTranslations } from 'shared-ui/lib/shared-translations';
import serviceEventCompleteReminderFormTranslation from './form/service-event/service-event-complete-reminder.form.translation';
import AcceptInvitationSceneTranslation from './scenes/auth/accept-invitation/AcceptInvitationSceneTranslation';
import ConfirmSceneTranslation from './scenes/auth/confirm/ConfirmSceneTranslation';
import ForgotSuccessSceneTranslation from './scenes/auth/forgot-success/ForgotSuccessSceneTranslation';
import ForgotSceneTranslation from './scenes/auth/forgot/ForgotSceneTranslation';
import LoginSceneTranslation from './scenes/auth/login/LoginSceneTranslation';
import RegisterSceneTranslation from './scenes/auth/register/register.translation';
import ResetSuccessSceneTranslation from './scenes/auth/reset-success/ResetSuccessSceneTranslation';
import ResetPasswordSceneTranslation from './scenes/auth/reset/ResetPasswordSceneTranslation';
import { FeedbackSceneTranslation } from './scenes/feedback/FeedbackScene.translation';
import HomeSceneTranslation from './scenes/HomeSceneTranslation';
import ReminderCreateSceneTranslation from './scenes/reminder/ReminderCreateSceneTranslation';
import ReminderEditSceneTranslation from './scenes/reminder/ReminderEditSceneTranslation';
import { ReminderIndexSceneTranslation } from './scenes/reminder/ReminderIndexSceneTranslation';
import ServiceEventCompleteReminderSceneTranslation from './scenes/service-event/ServiceEventCompleteReminderSceneTranslation';
import ServiceEventCreateSceneTranslation from './scenes/service-event/ServiceEventCreateSceneTranslation';
import ServiceEventEditSceneTranslation from './scenes/service-event/ServiceEventEditSceneTranslation';
import ServiceEventShowSceneTranslation from './scenes/service-event/ServiceEventShowSceneTranslation';
import PartnerEditSceneTranslation from './scenes/settings/PartnerEditSceneTranslation';
import UserEditSceneTranslation from './scenes/settings/UserEditSceneTranslation';
import { CustomersSceneTranslation } from './scenes/service-call/CustomersScene.translation';
import { CustomerVehiclesSceneTranslation } from './scenes/service-call/CustomerVehiclesScene.translation';
import { CustomerVehicleCreateSceneTranslation } from './scenes/service-call/CustomerVehicleCreateScene.translation';
import { DashboardSceneTranslation } from './scenes/service-call/DashboardScene.translation';
import { FaultShowSceneTranslation } from './scenes/service-call/FaultShowScene.translation';
import { ServiceCallApplySceneTranslation } from './scenes/service-call/ServiceCallApplyScene.translation';
import { TeamCreateSceneTranslation } from './scenes/team/TeamCreateScene.translation';
import { TeamIndexSceneTranslation } from './scenes/team/TeamIndexScene.translation';
import VehicleShowSceneTranslation from './scenes/vehicle/VehicleShowSceneTranslation';
import { ServiceCallInviteModalTranslation } from './components/scenes/vehicle-show-scene/ServiceCallInviteModal.translation';
import { StripeCancelSceneTranslation } from './scenes/stripe/StripeCancel.translation';
import { StripeChoosePaymentSceneTranslation } from './scenes/stripe/StripeChoosePaymentScene.translation';
import { StripeSceneTranslation } from './scenes/stripe/StripeScene.translation';
import { StripeSuccessSceneTranslation } from './scenes/stripe/StripeSuccess.translation';
import { StripeUseVoucherSceneTranslation } from './scenes/stripe/StripeUseVoucherScene.translation';
import { commonTranslation } from './translations/common.translation';
import { uploadTranslation } from './translations/upload.translation';
import { FeedbackTranslation } from './translations/feedback.translation';
import { licenseStatusTranslation } from './translations/license-status.translation';
import sidebarTranslation from './translations/sidebar.translation';
import { voucherTranslation } from './translations/voucher.translation';

export default _.merge(
  sharedTranslations,
  HomeSceneTranslation,
  VehicleShowSceneTranslation,
  ServiceCallInviteModalTranslation,
  UserEditSceneTranslation,
  ServiceEventCompleteReminderSceneTranslation,
  ServiceEventCreateSceneTranslation,
  ServiceEventEditSceneTranslation,
  ServiceEventShowSceneTranslation,
  ReminderEditSceneTranslation,
  ReminderCreateSceneTranslation,
  ResetSuccessSceneTranslation,
  ResetPasswordSceneTranslation,
  RegisterSceneTranslation,
  LoginSceneTranslation,
  ForgotSuccessSceneTranslation,
  ForgotSceneTranslation,
  ConfirmSceneTranslation,
  serviceEventCompleteReminderFormTranslation,
  PartnerEditSceneTranslation,
  ReminderIndexSceneTranslation,
  TeamIndexSceneTranslation,
  TeamCreateSceneTranslation,
  ServiceCallApplySceneTranslation,
  DashboardSceneTranslation,
  FaultShowSceneTranslation,
  CustomersSceneTranslation,
  CustomerVehiclesSceneTranslation,
  CustomerVehicleCreateSceneTranslation,
  AcceptInvitationSceneTranslation,
  sidebarTranslation,
  FeedbackSceneTranslation,
  FeedbackTranslation,
  commonTranslation,
  uploadTranslation,
  licenseStatusTranslation,
  StripeChoosePaymentSceneTranslation,
  StripeSceneTranslation,
  StripeUseVoucherSceneTranslation,
  StripeSuccessSceneTranslation,
  StripeCancelSceneTranslation,
  voucherTranslation
);
